import React, { useState } from "react";
import FinstreamSVG from "../../../assets/images/finstream.svg";
import FinstreamvfSVG from "../../../assets/images/finstreamvf.svg";
import FinscoreqsSVG from "../../../assets/images/finscoreqs.svg";
import FinscorefsSVG from "../../../assets/images/finscorefs.svg";
import FinscorevfQsSVG from "../../../assets/images/finscorevf-qs.svg";
import pull from "lodash/pull";
import isEmpty from "lodash/isEmpty";
import { useMutation, useQuery } from "react-query";
import { loadUsers } from "../../../queries/consumer/users";
import { useErrorHandler } from "react-error-boundary";
import { createErrors } from "../../../queries/helpers";
import { createApplication } from "../../../queries/consumer/application";
import union from "lodash/union";
import InfoModal from "./InfoModal";

const NewApplicationPage = ({ currentUser, history, toast }) => {
  const [appInfo, setAppInfo] = useState("finstreamds");
  const handleError = useErrorHandler();
  const [newApplication, setNewApplication] = useState({
    name: "",
    sandbox: true,
    userIds: [],
    // we want to have this by default, this is also forced in the backend!
    apiProducts: ['finstreamvf', 'finstreamds'],
  });

  const {
    isLoading,
    isError,
    data: users,
  } = useQuery("users", () => loadUsers(), {
    keepPreviousData: true,
  });

  const handleSelectApp = (e, apiProduct) => {
    if (e.target.classList.value.includes("active")) {
      e.target.classList.remove("active");
      setNewApplication((newApplication) => {
        let newApiProducts = newApplication.apiProducts;
        return {
          ...newApplication,
          apiProducts: pull(newApiProducts, apiProduct),
        };
      });
    } else {
      e.target.classList.add("active");
      setNewApplication((newApplication) => {
        let newApiProducts = newApplication.apiProducts;
        return {
          ...newApplication,
          apiProducts: union([apiProduct], newApiProducts),
        };
      });
    }
  };

  const handleAssignUser = (e, id) => {
    if (e.target.classList.value.includes("active")) {
      e.target.classList.remove("active");
      setNewApplication((newApplication) => {
        let newUserIds = newApplication.userIds;
        return { ...newApplication, userIds: pull(newUserIds, id) };
      });
    } else {
      e.target.classList.add("active");
      setNewApplication((newApplication) => {
        let newUserIds = newApplication.userIds;
        return { ...newApplication, userIds: union([id], newUserIds) };
      });
    }
  };

  const handleAppNameChange = (e) => {
    const name = e.target.value;
    setNewApplication((newApplication) => {
      return { ...newApplication, name: name };
    });
  };

  const newApp = useMutation(async (formData) => {
    await createApplication(formData);
  });

  const handleCreateApp = async () => {
    return await newApp
      .mutateAsync(newApplication)
      .then(() => {
        toast.success([
          {
            title: "Application has been created",
            body: newApplication.name,
          },
        ]);
        history.push("/applications");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to create application",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        return createErrors(error, "Failed to create application", handleError);
      });
  };

  return (
    <div className="container-sm">
      <h3 className="text-sm-center mb-45">New app</h3>

      <div className="mw-sm-400 mx-auto text-sm-center mb-5">
        <label className="d-block mb-3">Give your new app a name</label>
        <input
          className="fin-control"
          type="text"
          placeholder="eg My bank application"
          onChange={(e) => handleAppNameChange(e)}
        />
      </div>

      <div className="app-type-icons mb-5">
        <p className="text-sm-center mb-4">
          {/* Subscribe to <i>at least</i> one of the following APIs for this app */}
          Your Application will be subscribed to DATA API and VERIFICATION by default
        </p>
        <div className="row row-sm">
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finstreamds")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon active"
              // remove the onClick event to keep the default value
              // onClick={(e) => handleSelectApp(e, "finstreamds")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinstreamSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                FinsStream
                <br />
                <small>DATA API</small>
              </span>
            </a>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finstreamvf")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon active"
              // remove the onClick event to keep the default value
              // onClick={(e) => handleSelectApp(e, "finstreamvf")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinstreamvfSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                FinsStream
                <br />
                <small>
                  VERIFICATION
                  <br />
                  (Requires DATA API)
                </small>
              </span>
            </a>
          </div>
          {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finscoreqs")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon"
              onClick={(e) => handleSelectApp(e, "finscoreqs")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinscoreqsSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                Finclude Score
                <br />
                <small>QUESTIONNAIRE DATA</small>
              </span>
            </a>
          </div> */}
          {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finscorefs")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon"
              onClick={(e) => handleSelectApp(e, "finscorefs")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinscorefsSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                Finclude Score
                <br />
                <small>
                  PRE-AGGREGATED DATA
                  <br />
                  AD HOC
                </small>
              </span>
            </a>
          </div> */}
          {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finscoreqs")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon disabled"
              onClick={(e) => handleSelectApp(e, "finscoreqs")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinscorevfQsSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                Finclude Score
                <br />
                <small>
                  VERIFIED | QUESTIONNAIRE
                  <br />+ VERIFICATION
                </small>
              </span>
            </a>
          </div> */}
          {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("finscorebv")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon disabled"
              onClick={(e) => handleSelectApp(e, "finscorebv")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinstreamSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                Finclude Score
                <br />
                <small>
                  BEHAVIORAL | VERIFIED
                  <br />+ CONT VERIFICATION
                </small>
              </span>
            </a>
          </div> */}
          {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 mb-2 mb-sm-3 box-icon-container">
            <a
              className="btn-info-wrapper"
              data-toggle="modal"
              data-target="#modal-api-info"
              onClick={() => setAppInfo("magpie")}
            >
              <i className="icon-info" />
            </a>
            <a
              className="box box-icon disabled"
              onClick={(e) => handleSelectApp(e, "magpie")}
            >
              <span className="box-icon-wrapper">
                <img className="main-icon" src={FinstreamSVG} alt={""} />
                <svg
                  className="loader-icon"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 48 48"
                  style={{ enableBackground: "new 0 0 48 48" }}
                  xmlSpace="preserve"
                >
                  <path
                    className="st0"
                    d="M40,19.3c-0.3-0.8-0.6-1.7-1-2.5c-0.2-0.5-0.3-1.1,0-1.6l0.4-0.9c0.3-0.7,0.2-1.6-0.4-2.1L35.9,9
            	c-0.6-0.6-1.4-0.7-2.1-0.4L32.8,9c-0.5,0.2-1.1,0.2-1.6,0c-0.5-0.3-1.1-0.5-1.7-0.7c-0.5-0.2-0.9-0.6-1.2-1.1L28,6.2
            	C27.7,5.5,27,5,26.2,5h-4.5C21,5,20.3,5.5,20,6.2L19.3,8c-0.8,0.3-1.7,0.6-2.5,0.9c-0.5,0.2-1.1,0.3-1.6,0l-0.9-0.4
            	c-0.7-0.3-1.6-0.2-2.1,0.4L9,12.2c-0.6,0.6-0.7,1.4-0.4,2.1L9,15.2c0.2,0.5,0.2,1.1,0,1.6c-0.3,0.5-0.5,1.1-0.7,1.7
            	c-0.2,0.5-0.6,1-1.1,1.2L6.2,20C5.5,20.3,5,21,5,21.8v4.5C5,27,5.5,27.7,6.2,28l0.9,0.4c0.5,0.2,0.9,0.6,1.1,1.2
            	c0.3,0.8,0.7,1.6,1.1,2.4l-0.7,1.7c-0.3,0.7-0.2,1.6,0.4,2.1l3.2,3.2c0.6,0.6,1.4,0.7,2.1,0.4l0.9-0.4c0.5-0.2,1.1-0.2,1.6,0
            	c0.5,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.6,1.2,1.1l0.4,0.9c0.3,0.7,1,1.2,1.8,1.2h4.5c0.8,0,1.5-0.5,1.8-1.2l0.4-0.9
            	c0.2-0.5,0.6-0.9,1.2-1.1c0.6-0.2,1.1-0.4,1.7-0.7c0.5-0.2,1.1-0.3,1.6,0l0.9,0.4c0.7,0.3,1.6,0.2,2.1-0.4l3.2-3.2
            	c0.6-0.6,0.7-1.4,0.4-2.1L39,32.8c-0.2-0.5-0.2-1.1,0-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.5,0.6-1,1.1-1.2l0.9-0.4
            	c0.7-0.3,1.2-1,1.2-1.8v-4.5c0-0.8-0.5-1.5-1.2-1.8L40,19.3z M24.2,33.3c-5.3,0.1-9.7-4.2-9.6-9.6c0.1-5,4.2-9,9.1-9.1
            	c5.3-0.1,9.7,4.2,9.6,9.6C33.2,29.2,29.2,33.2,24.2,33.3z"
                  />
                </svg>
              </span>
              <span>
                Magpie
                <br />
                <small>Coming soon</small>
              </span>
            </a>
          </div> */}
        </div>
      </div>

      <div className="user-select-list mb-5">
        <p className="text-sm-center mb-4">
          <i>Optionally</i> assign more users to this app
        </p>
        <div className="d-flex flex-wrap justify-content-sm-center">
          {users && !isLoading && !isError && (
            <>
              {users.map((user, index) => (
                <div key={index}>
                  {user.id === currentUser.id ? (
                    <a
                      key={user.id}
                      className="btn-tag btn-tag-sm active disabled"
                      onClick={(e) => handleAssignUser(e, user.id)}
                    >
                      {user.fullName}
                    </a>
                  ) : (
                    <a
                      key={user.id}
                      className="btn-tag btn-tag-sm"
                      onClick={(e) => handleAssignUser(e, user.id)}
                    >
                      {user.fullName}
                    </a>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      <div className="text-center mt-4">
        <button
          href="app-show.php"
          id="submit"
          className="btn btn-main minw-200"
          disabled={isEmpty(newApplication.name)}
          onClick={() => handleCreateApp()}
        >
          Create app
        </button>
      </div>
      {!isEmpty(appInfo) && <InfoModal appInfo={appInfo} />}
    </div>
  );
};

NewApplicationPage.propTypes = {};

export default NewApplicationPage;
